import React from "react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-charcoal text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-6 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-cream/50 text-sm">
            © {currentYear} Stine Eskesen. Alle rettigheder forbeholdes.
          </p>
          <a
            href="/admin"
            className="text-cream/40 hover:text-cream/70 text-xs transition-colors duration-200"
            data-testid="footer-admin-link"
          >
            Admin
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
